import { Directive, Input, OnInit, TemplateRef } from '@angular/core';
import { ToastService } from './toast.service';

interface ToastContext {}

@Directive({ selector: '[toast]' })
export class ToastDirective implements OnInit {
  constructor(
    private readonly template: TemplateRef<ToastContext>,
    private readonly toastService: ToastService,
  ) {}

  @Input()
  toast: unknown;

  @Input()
  toastDuration = 1000 * 3;

  ngOnInit() {
    this.toastService.toast.next({
      template: this.template,
      duration: this.toastDuration,
    });
  }
}
